import { Component } from "@angular/core";

@Component({
    selector: "app-personalization-books",
    templateUrl: "./personalization-books.component.html",
    styleUrls: ["./personalization-books.component.scss"]
})
export class PersonalizationBooksComponent {}
